// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_1mg11o","container":"p_vK1t","content":"_25GCQ2","image":"_371Y8Z"};